/**
 * Cabecera del caso: título, dificultad y —con el acento cálido reservado a eso— la
 * sala y la hora del crimen (MVP §6.1). El acento `--color-crime` no aparece en ningún
 * otro sitio de la pantalla; es la única señal roja del juego.
 */

import type { Difficulty } from '@murdoku/engine';

import type { RoomVisual } from './visuals';

const DIFFICULTY_LABEL: Record<Difficulty['label'], string> = {
  facil: 'Fácil',
  media: 'Media',
  experta: 'Experta',
};

export interface CaseHeaderProps {
  title: string;
  opening: string;
  difficulty: Difficulty;
  crimeRoom: RoomVisual;
  crimeHour: string;
}

export function CaseHeader({
  title,
  opening,
  difficulty,
  crimeRoom,
  crimeHour,
}: CaseHeaderProps) {
  const Icon = crimeRoom.icon;
  return (
    <header className="flex flex-col gap-4">
      <div className="flex flex-wrap items-baseline gap-x-4 gap-y-2">
        <h1
          className="font-display leading-tight"
          style={{ fontSize: 'var(--text-display)' }}
        >
          {title}
        </h1>
        <span className="border-border text-text-muted rounded-pill border px-3 py-1 text-xs tracking-wide uppercase">
          {DIFFICULTY_LABEL[difficulty.label]} · {difficulty.clueCount} pistas
        </span>
      </div>

      <p className="text-text max-w-prose leading-relaxed">{opening}</p>

      <div
        className="text-crime-contrast shadow-hard flex w-fit items-center gap-2 rounded-lg px-3 py-2"
        style={{ backgroundColor: 'var(--color-crime)' }}
      >
        <Icon size={18} strokeWidth={2.25} aria-hidden="true" />
        <span className="text-sm">
          El crimen: <strong>{crimeRoom.name}</strong>, a las{' '}
          <strong className="font-display" style={{ fontSize: 'var(--text-hour)' }}>
            {crimeHour}
          </strong>
        </span>
      </div>
    </header>
  );
}
